<template>
  <header class="sticky-header">
    <div class="header-container">
      <!-- left -->
       <div class="header-left">
        <div class="name-container">
          <h1 class="name-part site-name">巡回健診の</h1>
          <h1 class="name-part site-name">メディカルサンテ</h1>
        </div>
       </div>
      <!-- center -->
       <div class="header-center">
        <img src="./assets/medicalsante.png" alt="メディカルサンテ" class="logo" />
       </div>
      <!-- right -->
       <div class="header-right">
        <nav class="site-name">
          <!-- desktop -->
          <ul class="nav-links desktop">
            <li v-for="item in items" :key="item.label">
              <a :href="item.href" @click="open = false">
                {{ item.label }}
              </a>
            </li>
          </ul>
          <!-- mobile -->
          <div class="dropdown mobile">
            <div class="dropdown-selected" @click="open = !open">
              {{ selectedLabel }}
            </div>
            <ul v-if="open" class="dropdown-list">
              <li v-for="item in items" :key="item.label">
                <a :href="item.href" @click="select(item)">
                  {{ item.label }}
                </a>
              </li>
            </ul>
          </div>
        </nav>
       </div>
      </div>
    </header>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <HelloSante msg="Welcome to Your Vue.js App"/>
</template>

<script>
import HelloSante from './components/HelloSante.vue'

export default {
  name: 'App',
  components: {
    HelloSante
  }
}
</script>

<script setup>
import { ref } from 'vue'

const open = ref(false)
const selectedLabel = ref('メニュー')

const items = [
  { label: 'ビジョン', href: '#section-1' },
  { label: 'ご紹介', href: '#section-2' },
  { label: '承ります', href: '#section-3' },
  { label: '会社概要', href: '#section-4' },
  { label: 'お問い合わせ', href: '#section-5' }
]

const select = (item) => {
  selectedLabel.value = item.label
  open.value = false
}
</script>

<style>
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0,0,0,1);
  width: 100%;
}
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.header-left, .header-right {
  flex: 1;
}
.header-left {
  text-align: left;
}
.header-center {
  flex: 0;
  display: flex;
  justify-content: flex-end;
}
.header-right {
  text-align: right;
}
.nav-links {
  list-style: none;
  display: flex;
  gap: 15px;
  margin: 0;
  margin-left: auto;
  flex-direction: row;
}
.logo {
  height:50px;
}

.name-container {
  display: flex;
  flex-wrap: wrap;
}
.site-name {
  font-size: 14px;
  font-weight: normal;
  margin: 0px;
}
@media (min-width: 800px) {
  .header-left .site-name {
    font-size: 16px;
  }
  .header-right .site-name {
    font-size: 12px;
  }
}
@media (min-width: 1024px) {
  .header-left .site-name {
    font-size: 18px;
  }
  .header-right .site-name {
    font-size: 18px;
  }
}

/* PC 用横並び */
.desktop {
  display: flex;
  gap: 1rem;
}

/* モバイル用ドロップダウンはデフォルト非表示 */
.mobile {
  display: none;
}

/* ドロップダウンの見た目 */
.dropdown {
  position: relative;
  width: 70%;
  margin-left: auto;
  margin-right: 0;
}

.dropdown-selected {
  padding: 0.5rem;
  background: #f4f6f9;
  cursor: pointer;
}

.dropdown-list {
  position: absolute;
  top: 2.2rem;
  left: 0;
  right: 0;
  background: #f4f6f9;
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-list li {
  padding: 0.5rem;
  cursor: pointer;
}

.dropdown-list li:hover {
  background: #eee;
}

/* 600px 以下で切り替え */
@media (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
</style>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 50px; */
}
</style>
